export default {
    name: "otp-form",
    props: ["instanceId"],
    emits: ["canContinue"],
    data() {
        return {
            otp: null,
            otpExpiry: 30,
            canResendOtp: true,
            timerCount: 0,
            otpTimeout: null,
            otpResendMessage: "Didn't receive OTP? Resend OTP",
            otpValidationMessage: null,
            otpIsVerified: true,
            loading: false,
            showOtpResendSuccessMessage: false
        };
    },
    methods: {
        getOtpExpiry() {
            settingsService.getOtpExpiry().then(
                successResponse => {
                    let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                    if (isSuccess) {
                        //success
                        console.log("success", successResponse);
                        this.otpExpiry = successResponse.data.otpExpiry;
                    }
                },
                errorResponse => {
                    //error
                    console.log("error", errorResponse);
                    //apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
                }
            );
        },
        disableResendOtpButton() {
            var self = this;
            self.canResendOtp = false;
            this.otpResendMessage = "Didn't receive OTP? Resend OTP in " + (this.otpExpiry - this.timerCount) + " seconds";
            this.otpTimeout = setTimeout(() => {
                this.timerCount++;
                if (this.timerCount === this.otpExpiry) {
                    self.canResendOtp = true;
                    this.otpResendMessage = "Didn't receive OTP? Resend OTP";
                    this.timerCount = 0;
                    this.clearOtpTimer();
                } else {
                    self.canResendOtp = true;
                    this.otpResendMessage = "Didn't receive OTP? Resend OTP in " + (this.otpExpiry - this.timerCount) + " seconds";
                    self.disableResendOtpButton();
                }
            }, 1000);
        },
        clearOtpTimer() {
            clearTimeout(this.otpTimeout);
        },
        resendOtp() {
            this.canResendOtp = false;
            customerService.resendOtp(this.instanceId).then(response => {
               if(response.status === 200){
                   console.log("Resend OTP", response);
                   var self = this;
                   this.showOtpResendSuccessMessage = true;
                   setTimeout(() => {
                       self.showOtpResendSuccessMessage = false;
                   }, 5000);
                   this.disableResendOtpButton();
               }
               else{
                   this.canResendOtp = true;
               }
            });
        },
        goBackToPreviousStep() {
            localStorageCacheHelper.removeOtpFormCache("instanceId");
            location.reload();
        },
        validateForm() {
            this.otpIsVerified = true;
            if(this.otp !== null && this.otp !== "") {
                this.otpValidationMessage = null;
                this.saveCustomerDetails();
            }
            else{
                this.otpValidationMessage = "Please enter OTP";
            }
        },
        saveCustomerDetails() {
            this.loading = true;
            customerService.verifyOtp(this.otp, this.instanceId).then(successResponse => {
                let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
                if (isSuccess) {
                    //success
                    this.otpIsVerified = successResponse.data.isOtpVerified;
                    if(this.otpIsVerified){
                        this.$emit("canContinue", {
                            canContinue: true,
                            instanceId: this.instanceId
                        });
                    }
                    this.loading = false;
                    console.log("success", successResponse);
                }
            });
        }
    },
    mounted: function () {
        this.getOtpExpiry();
    }
};